// FutureLab
import { ChatListChatRequestRoom } from '../components/chat/ChatListChatRequestRoom';

export function ChatRoomPendingPage() {
	return (
		<div className="flex h-[calc(100dvh-60px)] w-full min-w-0 overflow-hidden md:h-auto md:min-h-0 md:flex-1">
			<ChatListChatRequestRoom />
		</div>
	);
}
